import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

BlogSec1.propTypes = {};

function BlogSec1(props) {
  const { data,
    category,
    loader
  } = props;

  const renderPost = (idx) => <div key={idx.id} className="widget-blog-1" style={{
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "20px",
    backgroundColor: "#fff",
    // borderRadius: "8px",
    padding: "10px",
  }}>
    <img src={idx.bannerImage} alt="image" className="img-blog" style={{
      width: "200px",          // fixed width
      height: "150px",         // fixed height (square)
      objectFit: "cover",    // keeps full image clear, not cropped
      backgroundColor: "#f8f8f8",
      borderRadius: "8px",
      flexShrink: 0,           // prevents image from shrinking
    }}
    />
    <div className="content" style={{
      flex: 1,                // text takes remaining space
    }}>
      {/* <span className="sub-title">{idx.category}</span> */}
      <h4 className="main-title" style={{ margin: "8px 0" }}>
        <Link to={`/news/${idx.slug}`}>{idx.title}</Link>
      </h4>
      <p className="main-title">{idx.abstract}</p>
      {/* <div className="widget-button-underline" style={{ marginTop: "8px" }}>
                          <Link to={`/news/${idx.slug}`}>Read More</Link>
                        </div> */}
    </div>
  </div>
  return (
    <section>
      <div className="tf-container">

        {/* Indefinite Leave to Remain (ILR) */}
        <div className="blog wrap-blog stc">
          <div className="list-blog listBlog-wrap">
            <h5 className="main-heading">
              {category}
            </h5>
            {loader && <span>Loading News...</span>}
            <br />
            {data.map((idx) => (
              renderPost(idx)
            ))}

            {data.length > 0 ? (

              <div className="widget-button-underline">
                {/* <Link to="/blogsingle_v1">Read More</Link> */}
              </div>

            ) : (<i>
              There are no {category} news
            </i>)}
          </div>
        </div>

      </div>
    </section>
  );
}

export default BlogSec1;
